export enum AuthenticationType {
  USERINFO = 'USERINFO',
  MANUAL = 'MANUAL',
  DIALOG = 'DIALOG',
}
